import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './TaskWindowFooter.css';
import testable from '@xingternal/malt-util/testable';
import { QA_MALT } from '@xingternal/malt-constants';

const TestableDiv = testable(QA_MALT, 'div');

const TaskWindowFooter = ({ children, className, testId }) => (
  <TestableDiv className={classNames(styles.base, className)} testId={testId}>
    {children}
  </TestableDiv>
);

TaskWindowFooter.displayName = 'TaskWindowFooter';

TaskWindowFooter.propTypes = {
  /** A custom className for the footer container */
  className: PropTypes.string,
  /** Content of the footer */
  children: PropTypes.node,
  /** define a testid for the footer container */
  testId: PropTypes.string,
};

export default TaskWindowFooter;
